export default __webpack_public_path__ + "static/media/nodejs.0484604b.svg";